// base environment shared by all apps
// each app specifies its own environment.base.ts that is based off this file

// AltoAzureTablesUrl, EmbedAzureTablesUrl:
//  values are also stored in Web.config and StorageProvider.cs so update there also if changing here.

import { RawClientConfiguration } from "./adapt-client-configuration";

export const clientConfiguration: Partial<RawClientConfiguration> = {
    AdaptEnvironmentName: "Local",
    AltoApiBaseUri: "http://localhost:4300",
    AltoAzureTablesUrl: "https://adaptdev2.table.core.windows.net/",
    AltoBaseUri: "http://localhost:4305",
    AnalyticsProductId: "",
    ApiBaseUri: "/api",
    BoxClientId: "l4ljnh88sav6vg083t1nx6seu1vdpwnr",
    DeepDiveDomain: "https://adaptdeepdivestaging.z26.web.core.windows.net",
    DropboxAppKey: "kqq9nh24c7i0xp1",
    EmbedApiBaseUri: "/api",
    EmbedAzureTablesUrl: "https://adaptdev2.table.core.windows.net",
    EmbedBaseUri: "http://localhost:4301",
    FroalaKey: "7MD3aG3B2C5C3E2D3E2yQNDMIJd1IQNSEa2EUAf1XVFQa1EaD4D3B2I2A18A15A6C9D4D3==",
    GoogleApiKey: "AIzaSyDkD9k7-4i56CZfwZRUSY0chEYPURr5Kvw",
    GoogleClientId: "799098505879-p5uciuk6kges86pnnhil2rg84d31ee8e.apps.googleusercontent.com",
    IntercomAppId: "q32mupku",
    MicrosoftClientId: "4bdd55c9-a959-42c8-b866-174d1b46dcf3",
    OneDriveClientId: "8f51d602-b047-427a-bcdc-f802ff020035",
    SentryTraceLevelName: "Error",
    ServiceApiBaseUri: "http://localhost:4303",
    StripePublicKey: "pk_test_1FhAZMakNbB63zYwUjAgFfiv",
    ToasterTraceLevelName: "Warning",
    TraceLevelName: "Debug",
    TrustedVimeoDomain: "http://player.vimeo.com/video/*",
    DxLicenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjFjOTZlNDc3LWM2ZDItMTFlNC04MGM0LTAwMjU5MGQ5ZDVmZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.GDpRCIHf1yP4YH2oRdSxXhHHb1SAlMbVsy9Z3r61eFQKGLNT+a89SbJyJN7vwHyM5JPdtfHgDe0D4rV8wmOAjUN0WIzHahPXFKrZw0VVMB7lsIHkinccrjQoljPyyd1IAHEoOQ==",
};
